import styled from 'styled-components';

export const CurrentBurnoutSyndromeContainerStyled = styled.div`
  .loading_layout {
    height: calc(100vh - 186px);
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .section_introduce_layout {
    margin-bottom: 22px;
  }
  .section_chart_layout {
    margin-bottom: 24px;
    &:last-child {
      margin-bottom: 0px;
    }
  }
`;
